export * from './admin.js';
export * from './auth.js';
export * from './compliance.js';
export * from './error.js';
export * from './health.js';
export * from './kyc.js';
export * from './locale.js';
export * from './login.js';
export * from './onboarding.js';
export * from './places.js';
export * from './site.js';
/** Every route lives under this prefix (PLAN.md §11). */
export const API_PREFIX = '/api/v1';
//# sourceMappingURL=index.js.map